import { yupResolver } from '@hookform/resolvers/yup'
import { lazyLoad } from '@if/core/utils'
import * as yup from '@if/core/yup'
import { useMemo } from 'react'
import { Resolver } from 'react-hook-form'

export const getPersonSchema = lazyLoad(() =>
  yup.object({
    email: yup.string().email().required(),
    fullName: yup.string().required(),
    startDate: yup.string().required(),
    endDate: yup.string().nullable(),
    bambooId: yup.string().required(),
    team: yup.string().required(),
  }),
)

export type PersonSchemaType = yup.InferType<ReturnType<typeof getPersonSchema>>

export const usePersonResolver = () => {
  return useMemo<Resolver<PersonSchemaType>>(() => {
    return yupResolver(getPersonSchema())
  }, [])
}
